export const locale = {
  lang: 'pt',
  data: {
    MENU: {
      LOG: 'Log',
      COMPANY: 'Empresaas',
      USERS: 'Usuarios'
    }
  }
}
